/**
 * Where this copy of MartePOS was installed from.
 *
 * The Google Play build (a Trusted Web Activity — `android/twa-manifest.json`)
 * opens `/pos?src=play`. Google Play's payments policy lets an app be
 * „consumption-only": the shop signs in and uses a service it paid for
 * elsewhere. What the app may NOT do is point, inside the app, to a way of
 * paying other than Google Play's own. So in the Play build every place that
 * says HOW to pay — the accounts, the amount, „გადავრიცხე", the pay buttons —
 * is hidden, and the status (trial days, paid-until, overdue) stays, because a
 * shop has to know where it stands. The owner gets the payment details by
 * e-mail (the billing reminder, 104), which the policy allows.
 *
 * Remembered in localStorage rather than sessionStorage: a link from an
 * e-mail opens the app WITHOUT the marker, and the phone's Chrome shares this
 * storage with the app. Hiding the pay panel in that Chrome as well is the
 * safe side of the rule; a desktop browser never sees the marker.
 */

export const PLAY_PACKAGE_ID = 'com.martepos.app'
const KEY = 'martepos-channel'

/** Run once, before the router reads the address: note a Play launch and drop the marker from the URL. */
export function rememberInstallChannel(): void {
  try {
    const url = new URL(window.location.href)
    const fromPlay = url.searchParams.get('src') === 'play'
      || document.referrer.startsWith(`android-app://${PLAY_PACKAGE_ID}`)
    if (!fromPlay) return
    localStorage.setItem(KEY, 'play')
    if (url.searchParams.has('src')) {
      url.searchParams.delete('src')
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash)
    }
  } catch { /* storage blocked: the pay panel simply stays as on the web */ }
}

/** True inside the Google Play build — see the file comment for what it hides. */
export function isPlayInstall(): boolean {
  try { return localStorage.getItem(KEY) === 'play' } catch { return false }
}
